"use client";

import { cn } from "@/lib/utils";
import Link from "next/link";
import React from "react";
import { Button } from "../ui/button";
import { usePathname } from "next/navigation";

export default function Pagination({
  page,
  totalPages,
}: {
  page: number;
  totalPages: number;
}) {
  const pathname = usePathname();

  return (
    <div className="my-10 flex items-center justify-center space-x-6">
      <Button asChild>
        <Link
          href={{
            pathname: pathname,
            query: {
              page: page > 1 ? page - 1 : 1,
            },
          }}
          className={cn(page <= 1 && "pointer-events-none opacity-50")}
        >
          Previous
        </Link>
      </Button>
      <Button
        className={cn(page >= totalPages && "pointer-events-none opacity-50")}
        asChild
      >
        <Link
          href={{
            pathname: pathname,
            query: {
              page: page + 1,
            },
          }}
        >
          Next
        </Link>
      </Button>
    </div>
  );
}
